module.exports = __webpack_public_path__ + "img/single-site-screen.8bcd57b2.svg";